import { Link as RouterLink } from 'react-router-dom';
import { useDispatch } from 'store';
import { closeSubDrawer } from 'store/reducers/subdrawer';
import { t } from 'utils/getTranslations';
import SectionTitle from './SectionTitle';
import TimecardCenterForm from './TimecardCenterForm';
import UserDraftTimecardsList from './UserDraftTimecardsList';

const TimecardCenterContent = (): JSX.Element => {
    const dispatch = useDispatch();

    return (
        <div className="flex h-full flex-col">
            <div className="overflow-auto p-6">
                <TimecardCenterForm />
                <SectionTitle
                    title="timecards.continue-from-drafts"
                    rightComponent={
                        <RouterLink
                            className="text-fg hover:text-link no-underline hover:underline"
                            to={'timecards'}
                            onClick={() => dispatch(closeSubDrawer())}
                        >
                            {t('timecards.all-timecards')}
                        </RouterLink>
                    }
                    className="py-4"
                />
                <UserDraftTimecardsList />
            </div>
        </div>
    );
};

export default TimecardCenterContent;
